import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { removeUserFromGroup } from '../../services/GroupsService';
import { Group, AddUserToGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, AddUserToGroupRequest>;

function useDeleteUserFromGroup(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(removeUserFromGroup, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups', 'users'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteUserFromGroup;
